module.exports = __webpack_public_path__ + "static/media/SincerelyDiaryCoverSketches.4e07cb70.jpg";